import { merge } from 'lodash';
import { useMemo, useState } from 'react';
import { useQueryClient } from 'react-query';
import { useHistory, useLocation } from 'react-router-dom';

import { handleApiErrors } from '../../api/axiosInstance';
import { FAVR_COMPLIANCES_API } from '../../api/favr-compliances';
import usePaginatedComplianceWorklist from '../../hooks/queries/usePaginatedComplianceWorklist';
import useLocationSearchQueryParser from '../../hooks/useLocationSearchQueryParser';
import { replaceCurrentPageSearchQueryParams } from '../../utils/queryParams';

const useComplianceWorklist = () => {
  const history = useHistory();
  const location = useLocation();

  const initialFilters = useMemo(
    () => ({
      companyId: null,
      inGracePeriod: false,
      searchTerm: '',
      status: null,
      type: null,
    }),
    [],
  );

  const initialPageFilters = useLocationSearchQueryParser(location, initialFilters);
  const queryClient = useQueryClient();
  const [pageFilter, setPageFilter] = useState(initialPageFilters);
  const [isAddingNote, setIsAddingNote] = useState(false);

  const {
    query: complianceWorklistQuery,
    paginationConfig,
    handlePageChange,
    handlePageSizeChange,
  } = usePaginatedComplianceWorklist(pageFilter);

  const handleAddNoteToCompliance = async (complianceId, note, onSuccess) => {
    setIsAddingNote(true);

    try {
      const updatedNotes = await FAVR_COMPLIANCES_API.addNoteToFavrCompliance(
        complianceId,
        note,
        true,
      );
      queryClient.setQueryData(['fetchFavrComplianceNotes', complianceId], updatedNotes);
    } catch (error) {
      handleApiErrors(error.response);
    }

    setIsAddingNote(false);
  };

  const handleFiltersChange = newFilters => {
    setPageFilter(filter => {
      const updatedFilters = merge({ ...filter }, newFilters);
      replaceCurrentPageSearchQueryParams(history, updatedFilters);
      return updatedFilters;
    });
  };

  return {
    isAddingNote,

    pageFilter,
    paginationConfig,
    handlePageChange,
    handlePageSizeChange,
    complianceWorklistQuery,

    handleFiltersChange,
    handleAddNoteToCompliance,
  };
};

export default useComplianceWorklist;
